import React from 'react';
import { SkeletonRectangle } from 'components/Skeleton';
import styles from './DecisionView.module.scss';

const DecisionFilterSkeleton = () => (
  <SkeletonRectangle width="330px" height="44px" color="primary6" className={styles.createdDateSkeleton} />
);

export default DecisionFilterSkeleton;
